import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Ss=()=><svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M22.539 8.242H1.46V5.406h21.08v2.836zM1.46 10.812V24L12 18.11 22.54 24V10.812H1.46zM22.54 0H1.46v2.836h21.08V0z"/></svg>;
const Ig=()=><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="5"/><circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" stroke="none"/></svg>;
const Li=()=><svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z"/></svg>;
const Tk=()=><svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 0010.86 4.43v-7.15a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-.81.07z"/></svg>;
const Yt=()=><svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M23.5 6.19a3.02 3.02 0 00-2.12-2.14C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.38.55A3.02 3.02 0 00.5 6.19 31.6 31.6 0 000 12a31.6 31.6 0 00.5 5.81 3.02 3.02 0 002.12 2.14c1.88.55 9.38.55 9.38.55s7.5 0 9.38-.55a3.02 3.02 0 002.12-2.14A31.6 31.6 0 0024 12a31.6 31.6 0 00-.5-5.81zM9.75 15.02V8.98L15.5 12z"/></svg>;
const Sp=()=><svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.52 17.34c-.24.36-.66.48-1.02.24-2.82-1.74-6.36-2.1-10.56-1.14-.42.12-.78-.18-.9-.54-.12-.42.18-.78.54-.9 4.56-1.02 8.52-.6 11.7 1.32.42.18.48.66.24 1.02zm1.44-3.3c-.3.42-.84.6-1.26.3-3.24-1.98-8.16-2.58-11.94-1.38-.48.12-.96-.12-1.08-.6s.12-.96.6-1.08c4.38-1.32 9.78-.66 13.5 1.62.36.18.48.78.18 1.14zm.12-3.36C15.24 8.4 8.88 8.16 5.16 9.3c-.6.18-1.14-.18-1.32-.72-.18-.6.18-1.14.72-1.32 4.26-1.26 11.28-1.02 15.72 1.56.54.3.72 1.02.42 1.56-.3.42-.96.6-1.5.3z"/></svg>;

const CURRENT_PAGE = "Contact";
const NAV=[{label:"Home",href:"/"},{label:"About",href:"/about"},{label:"Fashboard",href:"/fashboard"},{label:"Articles",href:"/articles"},{label:"Podcast",href:"/podcast"},{label:"People",href:"/people"},{label:"Contact",href:"/contact"}];
const SOCIALS=[{icon:<Ss/>,label:"Substack",url:"https://materialtalk.substack.com"},{icon:<Ig/>,label:"Instagram",url:"https://instagram.com/materialtalk"},{icon:<Li/>,label:"LinkedIn",url:"https://linkedin.com/company/materialtalk"},{icon:<Tk/>,label:"TikTok",url:"https://www.tiktok.com/@emmafeldner?_r=1&_t=ZG-95JouNbMETZ"},{icon:<Yt/>,label:"YouTube",url:"https://youtube.com/@materialtalk"},{icon:<Sp/>,label:"Spotify",url:"https://open.spotify.com/show/04fMVuTgkMzrD6cNDZViiN"}];

// ── Page Data ────────────────────────────────────────────────────────────
const SECTIONS = [
  { title: null, body: "Material Talk exists to connect the people creating the future of fashion in real time: from new voices to established brands and technology builders. Have something to share, build, or explore together? Get in touch." },
];

export default function Contact() {
  const [hoveredNav, setHoveredNav] = useState(null);
  const [form, setForm] = useState({ firstName: "", lastName: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const [focused, setFocused] = useState(null);

  const handleSubmit = async () => {
    if (!form.firstName || !form.email || !form.message) { setError("Please fill in all required fields."); return; }
    try {
      const res = await fetch("https://api.materialtalk.co/api/collaborate", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (res.ok) { setSubmitted(true); setError(null); }
      else setError("Something went wrong. Please try again.");
    } catch { setError("Could not connect to the server."); }
  };

  const inp = (field) => ({
    width: "100%", padding: "14px 16px", background: "rgba(245,240,235,0.04)",
    border: focused === field ? "1px solid rgba(201,169,110,0.5)" : "1px solid rgba(201,169,110,0.15)",
    borderRadius: 2, color: "#f5f0eb", fontSize: 14, fontFamily: "'DM Sans', sans-serif",
    outline: "none", transition: "border-color 0.3s ease", boxSizing: "border-box", letterSpacing: "0.02em",
  });
  const lab = { fontSize: 10, letterSpacing: "0.2em", color: "#c9a96e", textTransform: "uppercase", marginBottom: 8, display: "block", fontWeight: 500 };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: "#0a0a0a", color: "#f5f0eb", fontFamily: "'DM Sans', sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;0,700;1,300;1,400&family=DM+Sans:wght@300;400;500&display=swap" rel="stylesheet" />

      {/* HEADER */}
      <header style={{
            padding: isMobile ? "20px 20px 0" : "20px 40px 0",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid rgba(199,125,255,0.15)",
            paddingBottom: 16,
          }}>
        <div style={{ flex: 1 }} />
        <div style={{ textAlign: "center" }}>
          <a href="/" style={{ textDecoration: "none" }}>
            <div style={{ fontSize: 10, letterSpacing: "0.4em", color: "#c9a96e", marginBottom: 4, fontWeight: 300 }}>EST. 2025</div>
            <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: isMobile ? 32 : 52, fontWeight: 300, letterSpacing: "0.12em", lineHeight: 1, background: "linear-gradient(180deg, #f5f0eb 0%, #c9a96e 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>MATERIAL TALK</div>
            <div style={{ fontSize: 9, letterSpacing: "0.35em", color: "rgba(201,169,110,0.6)", marginTop: 6, marginBottom: 16 }}>FASHION TECH MARKET INSIGHTS</div>
          </a>
          <nav style={{ display: "flex", gap: isMobile ? 12 : 28, flexWrap: "wrap", justifyContent: "center", borderTop: "1px solid rgba(201,169,110,0.1)", paddingTop: 12 }}>
            {NAV.map((item, i) => (
              <Link key={item.label} to={item.href} onMouseEnter={() => setHoveredNav(i)} onMouseLeave={() => setHoveredNav(null)}
                style={{ color: item.label === CURRENT_PAGE ? "#c9a96e" : hoveredNav === i ? "#c9a96e" : "rgba(245,240,235,0.7)", textDecoration: "none", fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase", fontWeight: 400, transition: "color 0.3s ease" }}>
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
        <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", paddingTop: 8 }}>
          <div style={{ display: "flex", gap: 16 }}>
            {SOCIALS.map(({icon,label,url}) => (
              <a key={label} href={url} title={label} target="_blank" rel="noopener noreferrer" style={{ color: "rgba(245,240,235,0.5)", transition: "color 0.3s", display: isMobile ? "none" : "flex", }}
                onMouseEnter={e=>e.currentTarget.style.color="#c9a96e"} onMouseLeave={e=>e.currentTarget.style.color="rgba(245,240,235,0.5)"}>{icon}</a>
            ))}
          </div>
        </div>
      </header>

      {/* CONTENT */}
      <main style={{ padding: "48px 40px", maxWidth: 1100, margin: "0 auto" }}>
        <div style={{ fontSize: 10, letterSpacing: "0.3em", color: "#c9a96e", marginBottom: 12, fontWeight: 500 }}>CONTACT</div>
        <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 42, fontWeight: 300, lineHeight: 1.15, margin: "0 0 48px 0" }}>Let's chat</h2>

        {SECTIONS.map((s, i) => (
          <div key={i} style={{ marginBottom: 44 }}>
            {s.title && <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontWeight: 400, margin: "0 0 16px 0" }}>{s.title}</h3>}
            <p style={{ fontSize: 15, lineHeight: 1.8, color: "rgba(245,240,235,0.7)", margin: 0, fontWeight: 300, maxWidth: 780 }}>{s.body}</p>
          </div>
        ))}

        <div style={{ borderTop: "1px solid rgba(201,169,110,0.15)", margin: "48px 0" }} />

        {/* Contact Form */}
        <div style={{ maxWidth: 600 }}>
          <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontWeight: 400, margin: "0 0 12px 0" }}>Contact us</h3>
          {/* <p style={{ fontSize: 13, color: "rgba(245,240,235,0.45)", margin: "0 0 32px 0", fontWeight: 300 }}>We'll get back to you within a week.</p> */}

          {submitted ? (
            <div style={{ padding: 32, border: "1px solid rgba(201,169,110,0.2)", borderRadius: 3, textAlign: "center" }}>
              <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 24, marginBottom: 8 }}>Thank you</div>
              <div style={{ fontSize: 13, color: "rgba(245,240,235,0.5)", fontWeight: 300 }}>We've received your inquiry and will be in touch soon.</div>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                <div>
                  <label style={lab}>First Name *</label>
                  <input type="text" value={form.firstName} onChange={e => setForm({...form, firstName: e.target.value})}
                    onFocus={() => setFocused("fn")} onBlur={() => setFocused(null)} style={inp("fn")} />
                </div>
                <div>
                  <label style={lab}>Last Name</label>
                  <input type="text" value={form.lastName} onChange={e => setForm({...form, lastName: e.target.value})}
                    onFocus={() => setFocused("ln")} onBlur={() => setFocused(null)} style={inp("ln")} />
                </div>
              </div>
              <div>
                <label style={lab}>Email *</label>
                <input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})}
                  onFocus={() => setFocused("em")} onBlur={() => setFocused(null)} style={inp("em")} />
              </div>
              <div>
                <label style={lab}>How can we collaborate? *</label>
                <textarea value={form.message} onChange={e => setForm({...form, message: e.target.value})}
                  onFocus={() => setFocused("msg")} onBlur={() => setFocused(null)} rows={5}
                  style={{ ...inp("msg"), resize: "vertical", minHeight: 120 }} />
              </div>
              {error && <div style={{ fontSize: 12, color: "#cc6666" }}>{error}</div>}
              <button onClick={handleSubmit}
                style={{ background: "#c9a96e", color: "#0a0a0a", border: "none", borderRadius: 2, padding: "14px 36px", fontSize: 11, letterSpacing: "0.2em", textTransform: "uppercase", fontWeight: 500, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", transition: "background 0.3s", alignSelf: "flex-start" }}
                onMouseEnter={e => e.currentTarget.style.background = "#d4b87a"} onMouseLeave={e => e.currentTarget.style.background = "#c9a96e"}>
                Send Inquiry
              </button>
            </div>
          )}
        </div>
      </main>

      {/* FOOTER */}
      <footer style={{
        padding: isMobile ? "24px 20px" : "24px 40px",
        borderTop: "1px solid rgba(199,125,255,0.08)",
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        justifyContent: "space-between",
        alignItems: "center",
        gap: isMobile ? 16 : 0,
      }}>
        <div style={{ fontSize: 10, color: "rgba(245,240,235,0.25)", letterSpacing: "0.15em" }}>
          © 2026 MATERIAL TALK. ALL RIGHTS RESERVED.
        </div>
        {isMobile && (
          <div style={{ display: "flex", gap: 16 }}>
            {SOCIALS.map(({icon, label, url}) => (
              <a key={label} href={url} title={label} target="_blank" rel="noopener noreferrer"
                style={{ color: "rgba(245,240,235,0.4)", display: "flex" }}>
                {icon}
              </a>
            ))}
          </div>
        )}
      </footer>
    </div>
  );
}
